import dismissibleCards from '../../data/dismissibleCards.json'

export const getDismissibleCards = () => {
  if (typeof dismissibleCards === 'undefined') {
    return []
  } else {
    return dismissibleCards
  }
}

export const getDismissibleCardById = (id: string) =>
  getDismissibleCards().find((card) => card.itemId === id)

export const getGroupsDismissibleCard = () =>
  getDismissibleCardById('smarty_groups_dashboard_card')
